import React from "react";
import PropTypes from "prop-types";

import { ENABLE_SENTRY_REPORTING } from "config/constants";

import styles from "./ErrorPage.css";
import nickBitmoji from "assets/img/error-bitmoji.png";

export default function ErrorPage(props) {
  const { error, info } = props;
  const status = error.status
    ? error.status
    : error.context
    ? error.context.status
    : null;

  if (!ENABLE_SENTRY_REPORTING) {
    return (
      <div className={styles.devError}>
        <h1>Something went wrong</h1>
        <pre>
          {error.toString()}
          {info && info.componentStack ? info.componentStack : null}
        </pre>
      </div>
    );
  }

  let subhead = "Something went wrong.";
  let message =
    "This page is currently unavailable. We alerted the developers that something unexpected happened.";
  let buttonText = "Try refreshing the page";
  let buttonLink = null;
  let buttonAction = () => {
    window.location.reload();
  };

  if (status === 404) {
    subhead = "We can’t find the page you’re looking for.";
    message =
      "It may have expired, or there could be a typo. Maybe you can find what you need on the dashboard.";
    buttonText = "Dashboard  →";
    buttonLink = "/";
    buttonAction = null;
  }

  if (status === 500) {
    message =
      "The server was unable to process your request. We alerted the developers that something unexpected happened.";
  }

  return (
    <div className={styles.error}>
      <img src={nickBitmoji} className={styles.img} />
      <div className={styles.text}>
        <h3 className={styles.subhead}>{subhead}</h3>
        <p className={styles.message}>{message}</p>
      </div>
      <a className={styles.button} href={buttonLink} onClick={buttonAction}>
        {buttonText}
      </a>
    </div>
  );
}

ErrorPage.propTypes = {
  message: PropTypes.string,
  error: PropTypes.instanceOf(Error).isRequired,
  info: PropTypes.shape({
    componentStack: PropTypes.string,
  }),
};
